export enum AgentRouteNames {
  AGENT = 'agent',
}

export enum AgentRoutePathNames {
  AGENT = 'agent',
}

export enum AgentLocalePrefix {
  AGENT = 'agent',
}
